import { useState } from 'react';
import { IconButton, paperClasses, Tooltip } from '@mui/material';
import { Box } from '@mui/system';

import { useFiles } from 'Lib/components/common/table/filesTable/context';
import PortalTypes from 'Lib/constants/app/portalTypes';
import FormDialog from 'Lib/muiComponents/dialog/FormDialog';
import TextField from 'Lib/muiComponents/form/TextField';
import { screenSize } from 'Lib/utilities/screenSize';

export default function Files({ openFileUpload, disableUpload }) {
    const { createFolder, portalTypeID } = useFiles();

    const [isCreating, setIsCreating] = useState(false);
    const { mobile } = screenSize();

    const isManagerPortal = portalTypeID === PortalTypes.Manager;

    const toggleNewFolderModal = () => setIsCreating(prevState => !prevState);

    const handleSubmit = async (values, form) => {
        await createFolder(values, form).then(() => {
            toggleNewFolderModal();
        });
    };

    const renderNewFolderModal = () => (
        <FormDialog
            open={isCreating}
            title="Create New Folder"
            ButtonProps={{ text: 'Create Folder' }}
            toggle={toggleNewFolderModal}
            onSubmit={handleSubmit}
            initialValues={{ path: '' }}
            sx={{
                [`& .${paperClasses.root}`]: {
                    width: { sm: '400px' }
                }
            }}
        >
            {() => <TextField id="path" name="path" placeholder="Enter Folder Name" />}
        </FormDialog>
    );

    return (
        <Box>
            <Box display="flex" gap={mobile ? 0 : 2}>
                {!disableUpload && (
                    <Tooltip title="Upload Files" arrow placement="bottom">
                        <Box>
                            <IconButton variant={mobile ? '' : 'regular'} onClick={() => openFileUpload()}>
                                upload_file
                            </IconButton>
                        </Box>
                    </Tooltip>
                )}
                {isManagerPortal && (
                    <Tooltip title="New Folder" arrow placement="bottom">
                        <Box>
                            <IconButton variant={mobile ? '' : 'regular'} onClick={toggleNewFolderModal}>
                                create_new_folder
                            </IconButton>
                        </Box>
                    </Tooltip>
                )}
            </Box>
            {renderNewFolderModal()}
        </Box>
    );
}
